import { useEffect } from "react";

/** Shared review shortcuts; native controls and modal workflows retain their keys. */
export const useBoardNavigation = (onStep: (direction: -1 | 1) => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.defaultPrevented ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        (event.key !== "ArrowLeft" && event.key !== "ArrowRight")
      )
        return;
      const target = event.target instanceof HTMLElement ? event.target : null;
      if (
        target?.isContentEditable ||
        target?.closest(
          'input, textarea, select, [role="slider"], [role="tablist"], [role="menu"], [role="listbox"]',
        ) ||
        Array.from(document.querySelectorAll('[role="dialog"]:not([aria-modal="false"]), [role="alertdialog"]')).some(
          (dialog) => !dialog.closest('[aria-hidden="true"], [hidden]') && dialog.getClientRects().length > 0,
        )
      )
        return;
      event.preventDefault();
      onStep(event.key === "ArrowRight" ? 1 : -1);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [enabled, onStep]);
};
